var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMultiDayEvent(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59961 10.7993L9.7998 10.7993C10.3521 10.7993 10.7998 10.3516 10.7998 9.79932L10.7998 6.19971C10.7998 5.64742 10.3521 5.19971 9.79981 5.19971L6.2002 5.19971C5.64791 5.19971 5.2002 5.64742 5.2002 6.19971L5.2002 6.3999L4 6.3999L4 6.19971C4 4.98468 4.98517 3.99951 6.2002 3.99951L9.79981 3.99951C11.0148 3.99951 12 4.98468 12 6.19971L12 9.79932C12 11.0143 11.0148 11.9995 9.7998 11.9995L9.59961 11.9995L9.59961 10.7993Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 8.39941L12.2021 8.39941C12.7544 8.39941 13.2021 7.9517 13.2021 7.39941L13.2021 3.7998C13.2021 3.24752 12.7544 2.7998 12.2021 2.7998L8.60254 2.7998C8.05026 2.7998 7.60254 3.24752 7.60254 3.7998L7.60254 4L6.40234 4L6.40234 3.7998C6.40234 2.58478 7.38751 1.59961 8.60254 1.59961L12.2021 1.59961C13.4172 1.59961 14.4023 2.58478 14.4023 3.7998L14.4023 7.39941C14.4023 8.61444 13.4172 9.59961 12.2021 9.59961L12.002 9.59961L12.002 8.39941Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60156 8.59941C1.60156 7.38439 2.58654 6.39941 3.80156 6.39941H7.40156C8.61659 6.39941 9.60156 7.38439 9.60156 8.59941V12.1994C9.60156 13.4144 8.61659 14.3994 7.40156 14.3994H3.80156C2.58654 14.3994 1.60156 13.4144 1.60156 12.1994V8.59941ZM3.80156 7.59941C3.24928 7.59941 2.80156 8.04713 2.80156 8.59941V12.1994C2.80156 12.7517 3.24928 13.1994 3.80156 13.1994H7.40156C7.95385 13.1994 8.40156 12.7517 8.40156 12.1994V8.59941C8.40156 8.04713 7.95385 7.59941 7.40156 7.59941H3.80156Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiDayEvent);
export default __webpack_public_path__ + "static/media/multi-day-event.940a08f9.svg";
export { ForwardRef as ReactComponent };